import { getLogoWhite } from "@/utils/assets";
import { content } from "@/i18n/content";
import { useLang } from "@/i18n/language";
import { BrandRule } from "./Primitives";

export function Hero() {
  const logo = getLogoWhite();
  const { lang } = useLang();
  const t = content[lang];

  return (
    <section
      id="top"
      className="relative overflow-hidden"
      style={{ background: "var(--gradient-hero)" }}
    >
      <span
        aria-hidden="true"
        className="absolute top-0 left-8 hidden h-full w-px bg-primary/40 md:block"
      />
      <div className="mx-auto max-w-6xl px-5 pt-32 pb-20 md:px-8 md:pt-40 md:pb-28">
        <div className="grid items-center gap-14 md:grid-cols-[1.1fr_0.9fr]">
          <div>
            <div className="flex items-center gap-4">
              <BrandRule />
              <span className="eyebrow text-primary">{t.hero.eyebrow}</span>
            </div>

            <h1 className="mt-6 text-5xl leading-[0.95] font-bold tracking-tight uppercase sm:text-6xl lg:text-7xl">
              {t.hero.titleTop}{" "}
              <span className="text-primary">{t.hero.titleAccent}</span>{" "}
              {t.hero.titleBottom}
            </h1>

            <p className="mt-6 max-w-xl font-serif text-xl leading-snug text-foreground/85 md:text-2xl">
              {t.hero.tagline}
            </p>

            <p className="mt-6 max-w-xl text-base leading-relaxed text-muted-foreground">
              {t.hero.lead}
            </p>

            <div className="mt-9 flex flex-wrap items-center gap-3">
              <a
                href="#enroll"
                className="rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition-transform hover:-translate-y-0.5"
                style={{ boxShadow: "var(--shadow-amber)" }}
              >
                {t.cta.apply}
              </a>
              <a
                href="#pathways"
                className="rounded-full border border-border px-6 py-3 text-sm font-semibold text-foreground transition-colors hover:border-primary hover:text-primary"
              >
                {t.cta.guide}
              </a>
            </div>

            <dl className="mt-12 grid max-w-lg grid-cols-3 gap-6 border-t border-border pt-8">
              {t.hero.stats.map((s) => (
                <div key={s.label}>
                  <dt className="text-3xl font-semibold text-primary">{s.value}</dt>
                  <dd className="mt-1 text-xs leading-snug text-muted-foreground">{s.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="relative flex justify-center">
            <div
              aria-hidden="true"
              className="absolute inset-0 m-auto size-64 rounded-full bg-primary/10 blur-3xl md:size-80"
            />
            <img
              src={logo.url}
              alt="Logotipo de Share The Med: cisne dentro del símbolo omega"
              className="relative w-56 max-w-full md:w-80"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
